module.exports = __webpack_public_path__ + "img/ic-acessibilidade-contraste-ac.dd5ade91.svg";